import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const reddit = defineConnector({
  identifier: "reddit",
  name: "Reddit",
  tagLine: "Social news and discussion",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://oauth\\.reddit\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an app",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Reddit App Preferences](https://www.reddit.com/prefs/apps) and create a new application to get your client ID and secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://www.reddit.com/api/v1/access_token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    scopes: () => ["read"],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://oauth.reddit.com/api/v1/me",
  },
});
